import { render } from "./Privacypolicy.vue?vue&type=template&id=14ae2aa3"
import script from "./Privacypolicy.vue?vue&type=script&lang=js"
export * from "./Privacypolicy.vue?vue&type=script&lang=js"

import "./Privacypolicy.vue?vue&type=style&index=0&id=14ae2aa3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__